module.exports = __webpack_public_path__ + "static/media/a56.94a98b6b.jpg";